const ww = window.innerWidth
const wh = window.innerHeight

const config = {
  scenesScrollW: [6000, 2325, 5000, 5000, 6000, 7000, 8000, 9000],
  ratioP: (wh / ww) / (812 / 375)
}

// 总滚动长度
config.totalScrollW = config.scenesScrollW.reduce((prev, current) => prev + current)

// 每个场景的时间轴占比
config.scenesScrollT = config.scenesScrollW.map(item => item / config.totalScrollW)

// 每个场景的起始时间
let sum = 0
config.scenesScrollD = []
config.scenesScrollT.forEach((item) => {
  config.scenesScrollD.push(sum)
  sum += item
})

export default config



// WEBPACK FOOTER //
// ./src/assets/config.js